document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('HomeCourseBannerModal');
  if (!modal || typeof modal.show !== 'function') return;

  const triggerId = modal.dataset.homeBannerTrigger;
  if (!triggerId) return;

  const trigger = document.getElementById(triggerId);
  if (!trigger) return;

  trigger.addEventListener('click', (event) => {
    event.preventDefault();
    modal.show(trigger);
  });
});
